import { createSelector } from 'reselect';
import { getUserSettings } from './getUserSettings';
import { getFbmAgentConsentedAt } from '../operators/userSettingsGetters';
export const hasProvidedFbmAgentConsent = createSelector([getUserSettings], userSettings => Boolean(getFbmAgentConsentedAt(userSettings)));